import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubNav from "../../../Shared/SubNav";
import io from "socket.io-client";
import socket from "../../../context/socket";
import _ from "lodash";
 
import AddMoreDreamPoints from "../../Modals/AddMoreDreamPoints";
import { FaPlus, FaSpinner } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import Swal from "sweetalert2";
import DeleteWarningModal from "./DeleteWarningModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { FadeLoader } from "react-spinners";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";

const DreamsIntoAction = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [showCards, setShowCards] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roomId = new URLSearchParams(useLocation().search).get("clientId");
  const [modalShow, setModalShow] = useState(false);
  const [dreamsIntoActionData, setDreamsIntoActionData] = useState({});
  const [dreamPoints, setDreamPoints] = useState();
  const [uniqueData, setUniqueData] = useState([]);
  const [finalResultData, setFinalResultData] = useState();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCards(true);
    }, 1000); // 1 second

    return () => clearTimeout(timer);
  }, []);

  

  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);
  console.log(
    "dreamPoints",
    dreamPoints,
    dreamsIntoActionData?.master_values,
    selectedCards,
    clientData
  );

  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, [dispatch, roomId]);

  useEffect(() => {
    if (clientData?.dreamPoints && Array.isArray(clientData.dreamPoints)) {
      setDreamPoints(clientData?.dreamPoints);
      const filteredData = clientData?.dreamPoints.filter(
        (item) => item.priority !== 0
      );

      // Set the filtered data
      console.log("filteredData", filteredData);
      const newFilterData = consolidateData(filteredData);
      setSelectedCards(newFilterData);
    } else {
      // Handle the case where dreamPoints is not available or not an array
      setDreamPoints([]);
      setSelectedCards([]); // ✅ always safe
    }
  }, [clientData]);

  const getCardData = async () => {
    try {
      const response = await api.get(
        `advisor/get_master_data/dream_action_points`
      );
      setDreamsIntoActionData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    getCardData();
  }, [roomId]);

  const fetchData = async () => {
    try {
      const response = await api.get(
        `advisor/personal_finance_ratio_6/${roomId}`
      );
      const data = response.data;
      setFinalResultData(data.final_result);
      // setDreamPoints(data.client.dreamPoints);

      // Filter out data where priority is 0
      // const filteredData = data.client.dreamPoints.filter((item) => item.priority !== 0);

      // // Set the filtered data
      // console.log("filteredData", filteredData)
      // const newFilterData = consolidateData(filteredData);
      // setSelectedCards(newFilterData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  function consolidateData(data) {
    const uniqueData = {};

    data.forEach((item) => {
      if (!uniqueData[item._id]) {
        uniqueData[item._id] = { ...item, action_data: [...item.action_data] };
      } else {
        uniqueData[item._id].action_data.push(...item.action_data);
      }
    });

    return Object.values(uniqueData);
  }

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message", {
        room: roomId,
        data: { selectedCards, dreamsIntoActionData },
      });
    }, 300),
    [selectedCards, roomId, dreamsIntoActionData]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [selectedCards, debouncedEmitMessage]);

  // Handle card selection
  const handleCardSelect = async (cardId, text, imgSrc) => {
    const alreadySelected = Array.isArray(selectedCards)
      ? selectedCards.find((card) => card._id === cardId)
      : null;

    // If the card is already selected, check with the API before removing it
    if (alreadySelected) {
      try {
        const response = await api.post(
          `advisor/checkExistFolio`,
          {
            client_id: roomId,
            goal_id: alreadySelected._id,
          }
        );

        if (response.data === true) {
          // Show Swal warning if goal is mapped to folio
          Swal.fire({
            icon: "warning",
            title: "Goal is mapped",
            text: "Please unmap the goal from the folios before removing.",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          });
        } else {
          // Safe to remove the selected card
          // setSelectedCards((prev) => {
          //   const updatedCards = prev.filter((card) => card._id !== cardId);
          //   return updatedCards.map((card, index) => ({
          //     ...card,
          //     priority: index + 1,
          //   }));
          // });
          setSelectedCards((prev) => {
          const updated = prev
            .filter((card) => card._id !== cardId) // remove unselected card
            .sort((a, b) => a.priority - b.priority) // ensure sorted
            .map((card, index) => ({
              ...card,
              priority: index + 1, // reassign clean 1,2,3,...
            }));

          return updated;
        });

        }
      } catch (error) {
        console.error("Error checking folio:", error);
      }
    } else {
      // If not selected before, add the card
      setSelectedCards((prev) => {
        const newPriority = prev.length + 1;
        return [...prev, { _id: cardId, priority: newPriority, text, imgSrc }];
      });
    }
  };

  // Get the card style
  const getCardStyle = (cardId) => ({
    backgroundColor: selectedCards?.some((card) => card._id === cardId)
      ? "#23674B"
      : "",
    color: "#000",
    border: "1px solid #0000001A",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    maxHeight: "90px",
  });
  const getCardTextStyle = (cardId) => ({
    color: selectedCards?.some((card) => card._id === cardId) ? "#fff" : "#000",
  });

  // Get the card priority number
  const getCardNumber = (cardId) => {
    const selectedCard = selectedCards?.find((card) => card._id === cardId);
    return selectedCard ? selectedCard.priority : "";
  };

  useEffect(() => {
    const combinedData = [
      ...(dreamPoints || []),
      ...(dreamsIntoActionData?.master_values || []),
    ];
    console.log('combinedData', dreamsIntoActionData?.master_values);

    // Remove duplicates based on the _id property
    const uniqueCombinedData = combinedData.reduce((acc, current) => {
      const x = acc.find((item) => item._id === current._id);
      if (!x) {
        acc.push(current);
      }
      return acc;
    }, []);

    // Set the unique data in state
    setUniqueData(uniqueCombinedData);
  }, [dreamPoints, dreamsIntoActionData]);

  const handleNext = async () => {
    if (!selectedCards || selectedCards.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Goals Selected",
        text: "Please select at least one goal before proceeding.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "swal-confirm-btn" },
      });
      return;
    }

    const nextUrl = `/plan-your-goals?clientId=${roomId}`;

    const allCards = uniqueData.map((card) => {
      const selectedCard = selectedCards?.find((c) => c._id === card._id);
      return selectedCard
        ? { ...card, priority: selectedCard.priority }
        : { ...card, priority: 0 };
    });

    const allData = {
      _id: roomId,
      dreamPoints: allCards,
    };

    try {
      const res = await api.post(
        `advisor/save_dream_points`,
        allData
      );
      console.log("save_dream_points response:", res.data);

      // Wait for Redux to update before navigating (optional)
      await dispatch(fetchClientData(roomId));

      socket.emit("navigate", { room: roomId, url: nextUrl });
      navigate(nextUrl);
    } catch (err) {
      console.error("Error saving dream points:", err);
    }
  };


  const handleBack = () => {
    const prevUrl = `/get-on-same-page?clientId=${roomId}`;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  const handleSave = (data) => {
    console.log("data", data.text.trim().replace(/\s+/g, " "));
    const updatedDreamPointsValues = [
      ...dreamPoints,
      {
        imgSrc: data.imgSrc,
        _id: data._id,
        text: data.text.trim().replace(/\s+/g, " "),
      },
    ];
    // console.log("updatedDreamPointsValues",updatedDreamPointsValues);
    setDreamPoints(updatedDreamPointsValues);
  };

  const [showModal, setShowModal] = useState(false);
  const [deleteGoalData, setDeleteGoalData] = useState(null);
  const [id, setDeleteGoalId] = useState(null);

  const handleDeleteGoal = (data, id) => {
    // console.log(id,"dddddd");
    setDeleteGoalData(data);
    setDeleteGoalId(id);
    // setShowModal(true);
  };
  // const handleConfirmDelete = async (data, id) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to delete this goal? This action cannot be undone.",
  //     icon: "warning",
  //     showCancelButton: false,
  //     confirmButtonText: "OK",
  //     customClass: {
  //       confirmButton: "swal-confirm-btn  ",
  //     },
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         // Ensure dreamPoints is populated
  //         if (!dreamPoints || dreamPoints.length === 0) {
  //           console.error("dreamPoints array is empty or undefined");
  //           return;
  //         }

  //         // Find the goal to delete
  //         const goalToDelete = dreamPoints.find((goal) => goal._id === id);

  //         if (!goalToDelete) {
  //           console.error("Goal not found in dreamPoints with ID:", id);
  //           return;
  //         }

  //         // Proceed with deletion if the goal exists
  //         if (!goalToDelete.action_data) {
  //           const updatedDreamPoints = dreamPoints.filter(
  //             (goal) => goal._id !== id
  //           );
  //           setDreamPoints(updatedDreamPoints);
  //         } else {
  //           await api.post(
  //             `advisor/delete_custom_dreams_action`,
  //             { _id: roomId, newEntryId: id }
  //           );
  //           fetchData(); // Refresh the data
  //           dispatch(fetchClientData(roomId));
  //         }

  //         Swal.fire({
  //           title: "Success",
  //           text: "Goal deleted successfully!",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //           customClass: {
  //             confirmButton: "swal-confirm-btn",
  //           },
  //         });
  //       } catch (error) {
  //         console.error("Error deleting the goal:", error);
  //         Swal.fire(
  //           "Error!",
  //           "There was an error deleting the goal. Please try again.",
  //           "error"
  //         );
  //       }
  //     }
  //   });
  // };


const handleConfirmDelete = async (data, id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to delete this goal? This action cannot be undone.",
    icon: "warning",
    confirmButtonText: "OK",
    customClass: {
      confirmButton: "swal-confirm-btn",
    },
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {

        // 1️⃣ API delete (if custom)
        if (data?.action_data) {
          await api.post(`advisor/delete_custom_dreams_action`, {
            _id: roomId,
            newEntryId: id,
          });
        }

        // 2️⃣ Prepare UPDATED data FIRST
        const updatedDreamPoints = dreamPoints.filter(
          (goal) => goal._id !== id
        );

        const updatedSelected = selectedCards.filter(
          (card) => card._id !== id
        );

        // 3️⃣ Update UI
        setDreamPoints(updatedDreamPoints);

        // 4️⃣ Save with CORRECT data
        await updateSelectedAndSave(updatedSelected, updatedDreamPoints);

        Swal.fire({
          title: "Success",
          text: "Goal deleted successfully!",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });

      } catch (error) {
        console.error("Error deleting the goal:", error);
        Swal.fire("Error!", "Something went wrong", "error");
      }
    }
  });
};

  const updateSelectedAndSave = async (updatedSelectedCards, updatedDreamPoints) => {
  try {
    const cleaned = updatedSelectedCards
      .sort((a, b) => a.priority - b.priority)
      .map((card, index) => ({
        ...card,
        priority: index + 1,
      }));

    setSelectedCards(cleaned);

    // 👉 USE UPDATED DATA (NOT STATE)
    const combinedData = [
      ...(updatedDreamPoints || []),
      ...(dreamsIntoActionData?.master_values || []),
    ];

    const uniqueCombinedData = combinedData.reduce((acc, current) => {
      const x = acc.find((item) => item._id === current._id);
      if (!x) acc.push(current);
      return acc;
    }, []);

    const allCards = uniqueCombinedData.map((card) => {
      const selected = cleaned.find((c) => c._id === card._id);
      return selected
        ? { ...card, priority: selected.priority }
        : { ...card, priority: 0 };
    });

    const payload = {
      _id: roomId,
      dreamPoints: allCards,
    };

    console.log("FINAL PAYLOAD", payload); // 🔥 debug

    await api.post(`advisor/save_dream_points`, payload);

    dispatch(fetchClientData(roomId));

  } catch (err) {
    console.error("Error updating priorities:", err);
  }
};
  const toTitleCase = (str) => {
    // Check if str is a valid string, return an empty string if not
    if (typeof str !== "string" || !str) {
      return "";
    }

    // Replace underscores with spaces, then capitalize each word
    return str
      .toLowerCase() // Convert the entire string to lowercase
      .split("_") // Split the string at underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words back with spaces
  };

  const formattedString = toTitleCase(dreamsIntoActionData?.master_type);

  return (
    <div div className="container">
      <DeleteWarningModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleConfirmDelete={handleConfirmDelete}
        deleteGoalData={deleteGoalData}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-10 col-12">
            <h2>Dreams into Action</h2>
            {/* <h2>{formattedString}</h2> */}
            <p className="fs-18">
              Give your investments purpose by having clearly defined goals!
            </p>
          </div>
          <div className="col-md-2 d-none d-md-block">
            <span className="para verify ">Monthly Surplus</span>
            <p className="fs-14 percen pt-3 ps-3">
              {finalResultData &&
                Math.round(finalResultData.reserve_to_surplus)}
              %
            </p>
            <h5 style={{ marginTop: "-60px" }}>
              {" "}
              {finalResultData &&
                formatRupees(finalResultData.monthly_surplus)}
            </h5>
          </div>
          <div className="col-md-2 d-block d-md-none">
            <span className="para verify">Monthly Surplus</span>
            <p
              className="fs-14 percen pt-3 ps-3 position-relative"
              style={{ left: "85%" }}
            >
              {finalResultData &&
                Math.round(finalResultData.reserve_to_surplus)}
              %
            </p>
            <h5 style={{ marginTop: "-60px" }}>
              {" "}
              {finalResultData &&
                formatRupees(finalResultData.monthly_surplus)}
            </h5>
          </div>
        </div>
      </div>
      {showCards ? (
        <div className="container mt-4 minht1">
          <div className="row gx-md-5 g-3 row-cols-lg-3 row-cols-md-2 row-cols-1 mb-2">
            {[...uniqueData]
              .sort((a, b) => {
                const isSelectedA = selectedCards?.some(
                  (card) => card._id === a._id
                );
                const isSelectedB = selectedCards?.some(
                  (card) => card._id === b._id
                );
                if (isSelectedA && !isSelectedB) return -1; // Selected comes first
                if (!isSelectedA && isSelectedB) return 1; // Unselected comes later
                // If both are selected or unselected, sort by priority
                const priorityA =
                  selectedCards?.find((card) => card._id === a._id)?.priority ||
                  0;
                const priorityB =
                  selectedCards?.find((card) => card._id === b._id)?.priority ||
                  0;
                return priorityA - priorityB;
              })
              .map((card, index) => (
                <div key={card._id} className="col">
                  <div
                    className={`row py-md-2 py-3 brdr goals position-relative`}
                    style={getCardStyle(card._id)}
                  >
                    <div
                      className="col-md-2 col-2 mt-mobile"
                      onClick={() =>
                        handleCardSelect(card._id, card.text, card.imgSrc)
                      }
                    >
                      <div
                        className={`border border-1 ${getCardNumber(card._id) ? "clrgrn" : ""
                          } circle`}
                      >
                        <h3 className="text-center lh-53 text">
                          {getCardNumber(card._id)}
                        </h3>
                      </div>
                    </div>
                    <div
                      className="col-md-6 col-6 mt-2"
                      onClick={() =>
                        handleCardSelect(card._id, card.text, card.imgSrc)
                      }
                    >
                      <div
                        className="reward-text-wrapper ps-2"
                        style={{
                          // maxHeight: "60px",
                          overflowY: "none",
                          lineHeight: "1.2",
                          fontSize: "14px",
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 200, hide: 400 }}
                          overlay={
                            <Tooltip id={`tooltip-${card._id}`}>
                              {card.text}
                            </Tooltip>
                          }
                        >
                          <p
                            className="reward24 mb-0 ms-2 ms-md-0 mt-2 mt-md-0"
                            style={getCardTextStyle(card._id)}
                          >
                            {(() => {
                              const words = card.text?.trim().split(/\s+/) || [];
                              const maxChar = 23; // 🔧 Adjust based on visual space
                              let currentLength = 0;
                              let shouldShowEllipsis = false;

                              const visibleWords = [];

                              for (let i = 0; i < words.length; i++) {
                                currentLength += words[i].length + 1; // +1 for space
                                if (currentLength <= maxChar) {
                                  visibleWords.push(words[i]);
                                } else {
                                  shouldShowEllipsis = true;
                                  break;
                                }
                              }

                              return visibleWords.map((word, idx) => (
                                <React.Fragment key={idx}>
                                  {word}
                                  {idx === 0 && <br />}
                                  {idx === visibleWords.length - 1 && shouldShowEllipsis && '...'}
                                  {" "}
                                </React.Fragment>
                              ));
                            })()}


                          </p>
                        </OverlayTrigger>
                      </div>
                    </div>
                    <div
                      className="col-md-4 col-4"
                      onClick={() =>
                        handleCardSelect(card._id, card.text, card.imgSrc)
                      }
                    >
                      {/* <img
                        src={`assets/images/${card.imgSrc}`}
                        alt=""
                        className="float-end text-color"
                        width={88}
                        height={56}
                      /> */}
                       <img
                          // src={`assets/images/goal-images/${card.imgSrc}`}
                           src={
                            dreamsIntoActionData?.master_values?.find((m) => m._id === card._id)?.imgSrc
                              ? `assets/images/goal-images/${dreamsIntoActionData.master_values.find((m) => m._id === card._id).imgSrc}`
                              : `assets/images/goal-images/Custom-Goal.svg`
                          }
                          
                          alt=""
                          className="float-end text-color"
                          width={100}
                          height={56}
                          style={{
                            //  width: "88px", height: "56px",
                            filter: selectedCards?.some((c) => c._id === card._id)
                              ? "" // keep original selected color
                              : "brightness(0) saturate(100%)" // converts to black
                          }}
                        />
                    </div>
                    {!dreamsIntoActionData?.master_values?.some(
                      (item) => item._id === card._id
                    ) && (
                        <MdOutlineCancel
                          className="text-danger cursor-pointer fs-3 dream-delete-icon"
                          onClick={() => handleConfirmDelete(card, card._id)}
                        />
                      )}
                  </div>
                </div>
              ))}

            <div className="col">
              <div
                className={`row py-md-2 py-3 brdr goals`}
                style={getCardStyle(-1)}
                onClick={() => setModalShow(true)}
              >
                <div className="col-md-2 col-2 mt-2">
                  <div className={`border border-1   circle`}>
                    <h3 className="text-center lh-53 clrgreen ">
                      <FaPlus />
                    </h3>
                  </div>
                </div>
                {/* < style={{color:"#d5d5d5"}}></> */}
                <div className="col-md-8 col-6 ">
                  <p className="reward24 text-dark pb-3 ps-2 pt-3">Add More</p>
                </div>
                <div className="col-md-4 col-4"></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center py-5">
          <FadeLoader color="#23674B" size={50} />
          {/* <span>Loading...</span> */}
        </div>
      )}
      <div className="container ">
        <div className="row my-4">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      <AddMoreDreamPoints
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={handleSave}
        roomId={roomId}
      />
    </div>
  );
};

export default DreamsIntoAction;
